import { ThreadWithLastMessage } from "@common/types/chat";

type ThreadReadState = Pick<
    ThreadWithLastMessage,
    "lastReadAt" | "lastMessageAt"
>;

export function isThreadUnread(thread: ThreadReadState): boolean {
    if (!thread.lastReadAt) {
        return true;
    }
    return !!thread.lastMessageAt && thread.lastReadAt < thread.lastMessageAt;
}
